<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'Card',
});
</script>

<template>
    <div class="base-card">
        <div class="title" v-if="$scopedSlots['title']">
            <slot name="title"></slot>
        </div>
        <div class="content">
            <slot></slot>
        </div>
    </div>
</template>

<style scoped lang="scss">
.base-card {
    /* Frame 1000005938 */

    box-sizing: border-box;

    /* Auto layout */
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 24px;
    gap: 32px;

    background: #FFFFFF;
    border: 1px solid #E4E4E4;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);
    border-radius: 8px;

    /* Inside auto layout */
    flex: none;
    order: 0;
    flex-grow: 0;
    font-family: Geist, sans-serif;


    .title {
        color: #020617;
        font-weight: 600;
        font-size: 20px;
        width: 100%;
    }

    .content {
        width: 100%;
        font-weight: 500;
        font-size: 16px;
        line-height: 20px;
        letter-spacing: 0;
        color: #71717A;
        padding: 0 !important;
    }
}
</style>
